import { Link } from "react-router-dom";
import "./widget.scss";
const Widget = ({ title, link, icon, number, diff }) => {
  return (
    <div className="widget">
      <div className="left">
        <span className="title">{title}</span>
        <span className="counter">{number}</span>
        <span className="link">
          <Link to="/school">
            <span className="text-[#8884d8] hover:underline">{link}</span>
          </Link>
        </span>
      </div>
      <div className="right">
        <div
          className={diff >= 0 ? "percentage positive" : "percentage negative"}
        >
          {/* {diff>0?<KeyboardArrowUpIcon />:<KeyboardArrowDown/> }
          {diff} % */}
        </div>
        {icon}
      </div>
    </div>
  );
};

export default Widget;
